import { AviaPassengerType } from '@websky/graphql';
import { PassengerConfigSegment, PassengerTypeConfig } from '../../../types';
import { PassengersState } from '../../../store/passengers/reducers';
import { Segment } from '../../../schemas/Segment';

export const isInfant = (passenger: PassengerTypeConfig) => {
	const infantTypes = [AviaPassengerType.INF, AviaPassengerType.INS];

	return (
		infantTypes.includes(passenger?.code as AviaPassengerType) ||
		infantTypes.includes(passenger?.parentCode as AviaPassengerType)
	);
};

export const canBeIncrease = (
	passenger: PassengerTypeConfig,
	config: PassengerTypeConfig[],
	passengers: PassengersState,
	totalCount: number,
	maxPassengersCount = 9
) => {
	if (totalCount >= maxPassengersCount) {
		return false;
	}

	const passengerCount = passengers[passenger.code];

	if (passenger.maxCount) {
		return passengerCount < passenger.maxCount;
	}

	if (!passenger.isAdult) {
		const adultCount = config.reduce<number>(
			(count, current) => count + (current.isAdult ? passengers[current.code] || 0 : 0),
			0
		);

		if (isInfant(passenger) && passengerCount >= adultCount) {
			return false;
		} else if (adultCount <= 0) {
			if (passenger.maxCountWithoutAdult && passengerCount < passenger.maxCountWithoutAdult) {
				return true;
			}

			return false;
		}
	}

	return true;
};

export const canBeDecrease = (
	passenger: PassengerTypeConfig,
	config: PassengerTypeConfig[],
	passengers: PassengersState
) => {
	const passengerCount = passengers[passenger.code];

	const passengersRequireAdult = config.filter(
		pass =>
			!pass.isAdult &&
			passengers[pass.code] &&
			(!pass.maxCountWithoutAdult || passengers[pass.code] > pass.maxCountWithoutAdult)
	);

	if (passengerCount <= 0) {
		return false;
	} else if (passenger.isAdult && config.some(type => !type.isAdult && passengers[type.code] > 0)) {
		const adultsCount = config.reduce<number>(
			(count, current) => count + (current.isAdult ? passengers[current.code] || 0 : 0),
			0
		);

		if (adultsCount <= 1 && passengersRequireAdult.length) {
			return false;
		}
	}

	return true;
};

export const isRoutesMatch = (route: PassengerConfigSegment, segment: Segment) => {
	return (
		(route.arrival === '*' || segment.arrival?.iata === route.arrival) &&
		(route.departure === '*' || segment.departure?.iata === route.departure)
	);
};
